import { useState, useCallback } from 'react';

import { validateEmail } from '@utilities/utils';

export type EmailState = {
  value: string;
  isValid: boolean;
  isEmpty: boolean;
  isExisting: boolean;
  isSubmittedSimilar: boolean;
};

export const useEmailState = (initialEmail: string = '') => {
  const [emailState, setEmailState] = useState<EmailState>({
    value: initialEmail,
    isValid: true,
    isEmpty: false,
    isExisting: false,
    isSubmittedSimilar: false,
  });

  const updateEmailState = useCallback((updates: Partial<EmailState>) => {
    setEmailState((prev) => ({ ...prev, ...updates }));
  }, []);

  const handleEmailChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      const value = event.target.value.trim();
      updateEmailState({
        value,
        isEmpty: false,
        isValid: true,
        isExisting: false,
      });
    },
    [updateEmailState],
  );

  const validateEmailState = useCallback(
    (email: string, customerEmail?: string) => {
      const isEmailBlank = email === '';
      const isSubmittedEmailSimilar = email === customerEmail;
      const isValid = isEmailBlank ? true : validateEmail(email);

      updateEmailState({
        isEmpty: isEmailBlank,
        isSubmittedSimilar: isSubmittedEmailSimilar,
        isValid,
      });

      return !isEmailBlank && !isSubmittedEmailSimilar && isValid;
    },
    [updateEmailState],
  );

  return {
    emailState,
    updateEmailState,
    handleEmailChange,
    validateEmailState,
  };
};
